import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import { TableWrapper, FullTable, CustomDelete, SelectedFilters } from 'components';
import { RolePermission, PermissionList, useModal, tagEnums, sortListByKey } from 'utils';
import { resourceActions, tagActions } from 'store';
import { ACTION_TYPE, resourceBody, resourceHead, resourceNotYet } from './constants';
import { AddResource } from './fragments';

const DELETE_RESOURCE = 'DELETE_RESOURCE';
export const Resource = () => {
    const resourceList = useSelector((state) => state.resource.resourceList);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const info = location?.state;
    const { open } = useModal();
    const tagList = useSelector((state) => state.tags.tagList);

    /**
     * The only filter this grid has.
     *
     * There is no filter popover here, unlike the other grids: `GetResourceQuery` accepts `tags` and
     * nothing else (see `resource.service.ts` — `filter.tags` is the single condition it builds on
     * top of the permission scope), and Tags already has its own control in the column header. A
     * popover would sit empty.
     */
    const filtersList = [{ name: 'Tag', key: 'tags', options: tagList, loading: !tagList?.length }];

    const renderParams = () => {
        const filteredInfo = {
            ...info,
        };
        filteredInfo.skip = info?.skip ? info?.skip : 0;
        filteredInfo.limit = 50;
        delete filteredInfo.page;
        delete filteredInfo.activeTab;
        delete filteredInfo.name;
        return filteredInfo;
    };
    const getResource = (load) => {
        dispatch(resourceActions.getResource(renderParams(), load));
    };

    useEffect(() => {
        dispatch(tagActions.getTags({ module: tagEnums.RESOURCE }));
    }, []);

    useEffect(() => {
        getResource();
    }, [info]);

    const handleNavigate = (id) => {
        // if (RolePermission([PermissionList.FS_READ?.code])) {
        navigate(`/resource/${id}`);
        // }
    };

    const handleClickButton = (item, name) => {
        if (name === 'edit') {
            open(<AddResource info={item} closeToSuccess={() => getResource('noLoad')} />);
        }
        if (name === 'delete') {
            open(
                <CustomDelete
                    text="Are you sure you want to delete this folder? This action is not reversible."
                    info="Delete Folder"
                    handleDel={() => dispatch(resourceActions.deleteResource(item?.id))}
                    actionType={DELETE_RESOURCE}
                    innerText={'Delete'}
                    afterSuccess={() => getResource('noLoad')}
                />
            );
        }
    };

    return (
        <TableWrapper
            buttonsTab={true}
            buttonsTabAddButton={RolePermission([PermissionList.MANAGE_RESOURCE?.code])}
            addButtonText={'Add Folder'}
            handleOpenClose={() => open(<AddResource closeToSuccess={getResource} />)}
        >
            <div>
              <SelectedFilters filtersList={filtersList} doNotCrop />
            </div>

            <FullTable
                head={resourceHead()}
                body={resourceBody(renderParams())}
                loadingType={ACTION_TYPE}
                list={sortListByKey(resourceList?.resources, 'name', info)}
                listCount={resourceList?.count}
                handleClick={handleNavigate}
                handleClickButton={handleClickButton}
                notYet={resourceNotYet}
                detailPage={(item) => `/resource/${item?.id}`}
                margin={'12px 0 0 0'}
            />
        </TableWrapper>
    );
};
